import React from "react";

interface ModeRendererProps {
  brand: string;
  today: string;
  Copy: string;
}

export function VasarelyEdfMode({ brand }: ModeRendererProps) {
  const width = 794;
  const height = 1123;

  return (
    <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg">
      <defs>
        <radialGradient id="edfGradient" cx="50%" cy="50%" r="60%">
          <stop offset="0%" style={{ stopColor: "#FF8C00", stopOpacity: 1 }} />
          <stop offset="50%" style={{ stopColor: "#FF6600", stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: "#001F3F", stopOpacity: 1 }} />
        </radialGradient>
      </defs>
      <rect width={width} height={height} fill="url(#edfGradient)" />
      <g transform={`translate(${width / 2}, ${height / 2})`}>
        {Array.from({ length: 20 }).map((_, r) => (
          <circle
            key={`core-${r}`}
            cx={0}
            cy={0}
            r={(r + 1) * 20}
            fill="none"
            stroke="#FFFFFF"
            strokeWidth={r % 4 === 0 ? 2.5 : 1.5}
            opacity={0.35 - r * 0.012}
          />
        ))}
        {Array.from({ length: 24 }).map((_, i) => {
          const angle = (i / 24) * 2 * Math.PI;
          const x = Math.cos(angle) * 380;
          const y = Math.sin(angle) * 380;
          return (
            <line
              key={`rad-${i}`}
              x1={0}
              y1={0}
              x2={x}
              y2={y}
              stroke="#FF8C00"
              strokeWidth={i % 4 === 0 ? 2 : 1}
              opacity={0.25}
            />
          );
        })}
        <circle cx={0} cy={0} r={60} fill="none" stroke="#FF8C00" strokeWidth={4} opacity={0.7} />
        <circle cx={0} cy={0} r={40} fill="#FF6600" opacity={0.4} />
      </g>
    </svg>
  );
};
